import {
  POPUPS_HIDE_INTRO_POPUPS,
  POPUPS_SHOW_SCENE_ERRORS,
  POPUPS_HIDE_SCENE_ERRORS,
  POPUPS_CONF_OPEN,
  POPUPS_CONF_CLOSE,
  SCENE_ITEM_PICKED_UP,
  POPUPS_RESET_INTRO,
  POPUPS_CONF_CLEAR,
  TAC_REMOVE_ITEM,
  TAC_SET_USE_MOUNTING_RAIL,
  POPUPS_MOUNTING_RAIL_SHEET_OPEN,
  POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP,
  POPUPS_SUPPLY_BANNER_CLOSE,
  POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE,
  POPUPS_OVERLAY_ACTIVE,
  POPUPS_SET_INTRO_POPUPS_VISIBLE,
  POPUPS_SET_HAS_SHOWN_INTRO_POPUPS,
  POPUPS_SCROLL_EXCEPTION,
  POPUPS_HANDLE_POPUPS_ON_ADD_ITEM,
  POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM,
  POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING,
  POPUPS_SET_SURVEY_VISIBLE,
  POPUPS_SET_SURVEY_STATE,
  POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP,
} from '../actionConstants';
import defaultState from './popupsDefaultState';
import { Popups } from './popupsTypes';

export default (state: Popups = defaultState, action: any) => {
  switch (action.type) {
    case POPUPS_HANDLE_POPUPS_ON_ADD_ITEM:
      return {
        ...state,
        ...action.payload,
      };

    case POPUPS_HANDLE_POPUPS_ON_UPDATE_ITEM:
      return {
        ...state,
        ...action.payload,
      };
    case POPUPS_SET_CUTTABLE_MOUNTING_RAIL_HINT_CHECK_PENDING:
      return {
        ...state,
        ...action.payload,
      };
    case TAC_REMOVE_ITEM:
    case TAC_SET_USE_MOUNTING_RAIL:
      return {
        ...state,
        hasHadUserInteraction: true,
      };
    case SCENE_ITEM_PICKED_UP:
      if (
        state.showPegboardHint &&
        state.showPegboardHint.itemid === action.payload.item.itemid
      ) {
        return {
          ...state,
          showPegboardHint: null,
          hasShownPegboardHint: true,
          showDoorsHint: null,
        };
      }
      if (state.showDoorsHint) {
        return {
          ...state,
          showDoorsHint: null,
        };
      }
      return state;
    case POPUPS_SHOW_SCENE_ERRORS:
      return {
        ...state,
        sceneErrorVisible: true,
      };
    case POPUPS_HIDE_SCENE_ERRORS:
      return {
        ...state,
        sceneErrorVisible: false,
      };
    case POPUPS_HIDE_INTRO_POPUPS:
      if (state.introPopupsVisible) {
        return {
          ...state,
          introPopupsVisible: false,
        };
      }
      return state;
    case POPUPS_CONF_OPEN:
      return {
        ...state,
        confDialog: {
          ...state.confDialog,
          open: true,
        },
      };
    case POPUPS_CONF_CLOSE:
      return {
        ...state,
        confDialog: {
          open: false,
          closedId: action.payload.closedId,
        },
      };
    case POPUPS_CONF_CLEAR:
      return {
        ...state,
        confDialog: {
          ...state.confDialog,
          closedId: null,
        },
      };
    case POPUPS_SUPPLY_BANNER_CLOSE:
      return {
        ...state,
        supplyBannerClosed: true,
      };
    case POPUPS_MOUNTING_RAIL_SHEET_OPEN: {
      return {
        ...state,
        hasShownMountingRailSheet: true,
      };
    }

    case POPUPS_RESET_INTRO:
      return defaultState;

    case POPUPS_SET_HAS_SHOWN_FILTER_INTRO_POPUP:
      return {
        ...state,
        hasShownFilterIntroPopup: action.payload.hasShownFilterIntroPopup,
      };

    case POPUPS_SET_FILTER_INTRO_POPUP_VISIBLE:
      return {
        ...state,
        filterIntroPopupVisible: action.payload.filterIntroPopupVisible,
      };

    case POPUPS_OVERLAY_ACTIVE:
      return {
        ...state,
        overlayActive: action.payload.state,
      };

    case POPUPS_SCROLL_EXCEPTION:
      return {
        ...state,
        scrollException: action.payload.state,
      };

    case POPUPS_SET_INTRO_POPUPS_VISIBLE:
      return {
        ...state,
        introPopupsVisible: action.payload.introPopupsVisible,
      };

    case POPUPS_SET_HAS_SHOWN_INTRO_POPUPS:
      return {
        ...state,
        hasShownIntroPopups: true,
      };

    case POPUPS_SET_SURVEY_VISIBLE:
      return {
        ...state,
        surveyVisible: action.payload.surveyVisible,
      };

    case POPUPS_SET_SURVEY_STATE:
      return {
        ...state,
        surveyState: action.payload.surveyState,
      };

    case POPUPS_SET_ERROR_HANDLING_PENDING_TIMESTAMP:
      return {
        ...state,
        errorHandlingPendingTimestamp:
          action.payload.errorHandlingPendingTimestamp,
      };

    default:
      return state;
  }
};
